module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/list_of_plates"
    }
  }, [_vm._v("List of Plates")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/list_of_maps"
    }
  }, [_vm._v("List of Maps")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_vm._v("Preface")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgements"
    }
  }, [_vm._v("Acknowledgements")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-front"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/naming"
    }
  }, [_vm._v("Naming Conventions")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-front1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue"
    }
  }, [_vm._v("Prologue")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter_01"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("1")]), _vm._v(" Never was a Kingdom Less Prepared")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter_02"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("2")]), _vm._v(" Grey")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("3")]), _vm._v(" Jervis")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("4")]), _vm._v(" Ostend and Back")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("5")]), _vm._v(" The Knife-Edge")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("6")]), _vm._v(" The Capture of Tobago")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("7")]), _vm._v(" A Lock Step Banditti")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("8")]), _vm._v(" Landing and Consolidation")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("9")]), _vm._v(" Falstaff’s Corps")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("10")]), _vm._v(" Saint Lucia")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("11")]), _vm._v(" High-Water Mark")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("12")]), _vm._v(" Enter Hugues")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("13")]), _vm._v(" We Have Been Greatly Neglected")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("14")]), _vm._v(" Prize Money")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("15")]), _vm._v(" Daily Expected")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("16")]), _vm._v(" The Cost")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("17")]), _vm._v(" The People")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-back"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "toc-backa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_01#app1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-back_float"
  }, [_vm._v("I")]), _vm._v(" British Forces in Windward & Leeward Islands June 1793")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "toc-backa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-back_float"
  }, [_vm._v("II")]), _vm._v(" Return of Troops Disembarked at Barbados 1 February 1794")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "toc-backa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-back_float"
  }, [_vm._v("III")]), _vm._v(" French Garrison of Martinique February 1794")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "toc-backa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-back_float"
  }, [_vm._v("IV")]), _vm._v(" Returns of British Forces in Windward & Leeward Islands in 1794")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "toc-backa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-back_float"
  }, [_vm._v("V")]), _vm._v(" State of Martinique Garrison in November 1794")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "toc-backa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-back_float"
  }, [_vm._v("VI")]), _vm._v(" Grey’s Officers")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "toc-backa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-back_float"
  }, [_vm._v("VII")]), _vm._v(" Royal Navy Squadron at Martinique, February 1794")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "toc-backa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix_08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-back_float"
  }, [_vm._v("VIII")]), _vm._v(" Royal Navy Squadron at Guadeloupe, April 1794")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "toc-back"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0